var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C4.43 1 2 4.4 2 8C2 9.48 2.23 10.89 2.47 12H9.33C9.5 11.46 9.71 10.92 9.93 10.37C10.46 9.05 11 7.69 11 6C11 3.52 9.62 1 7 1ZM3 16C3 17.65 4.35 19 6 19C7.65 19 9 17.65 9 16V14H3V16ZM17 5C14.38 5 13 7.51 13 10C13 11.69 13.54 13.05 14.07 14.37C14.29 14.92 14.5 15.45 14.67 16H21.53C21.77 14.89 22 13.48 22 12C22 8.4 19.57 5 17 5ZM15 20C15 21.65 16.35 23 18 23C19.65 23 21 21.65 21 20V18H15V20Z",
    fill: "#005D0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.0d5e844c72f710a2ad188ce832e6ab89.svg";
export { ForwardRef as ReactComponent };